import React from 'react'
import { FinCrimeCol, FinancialCrimeRow, FinancialCrimesTitle, FinancialCrimessubTitle , FinancialCrimesStattext, FinancialCrimesStatData} from './StyledComponents'
import { financialCrimesData } from '../../../data/websiteData'
import { Grid, Row, Col } from '../../../styles/GlobalTheme/GlobalStyledComponents';
import Fade from 'react-reveal/Fade';


const FinancialCrimeData = () => {
    return (
        <FinCrimeCol>
        <Grid>
            <Fade animateIn='fadeIn' animateOut='fadeOut'>
                <FinancialCrimesTitle>{financialCrimesData.title}</FinancialCrimesTitle>
                <FinancialCrimessubTitle>{financialCrimesData.content}</FinancialCrimessubTitle>
                <FinancialCrimeRow justifyContent="space-between">
                {financialCrimesData.stats.map((item, index) => (
                    <Col>
                        <FinancialCrimesStattext>{item.text}</FinancialCrimesStattext>
                        <FinancialCrimesStatData>{item.data}</FinancialCrimesStatData>
                    </Col>
                ))}
                </FinancialCrimeRow>
            </Fade>
        </Grid>
        </FinCrimeCol>
    )
}

export default FinancialCrimeData
